'use client';

import { FunctionComponent } from 'react';

import type { Content } from '@/services/isomorphic/ContentService';
import { NavigationTiles } from '@/react/components/content/models/NavigationTiles';
import { DataModelTarget } from '@/services/isomorphic/integrations/BuilderService';
import { MarketingBanner } from '@/react/components/content/main/MarketingBanner';
import BuilderContent from '../BuilderContent';

export interface IBuilderRenderProps {
  /**
   * The content already fetched from builder.io.
   */
  content: Content;
  /**
   * Optional callback for handling when links are clicked.
   */
  handleLinkClick?: () => void;
}

/**
 * Renders the DataModel as a component.
 */
export const DataModel: FunctionComponent<IBuilderRenderProps> = ({
  content,
  handleLinkClick
}) => {
  switch (content.type) {
    case DataModelTarget.MarketingBannerModel:
      if (!content.dataModel) return null;
      return (
        <MarketingBanner
          banners={content.dataModel.banners}
          sliderDelay={content.dataModel.sliderDelay}
        />
      );
    case DataModelTarget.NavigationContentModel:
      return (
        <NavigationTiles
          handleLinkClick={handleLinkClick}
          tiles={content.dataModel.tiles}
        />
      );
    // The category data model is a hybrid data model and contains regular
    // content in the data field.
    case DataModelTarget.CategoryModel:
    case DataModelTarget.ProductModel:
    case DataModelTarget.PageModel:
    case DataModelTarget.PromotionMessageModel:
      return <BuilderContent content={content} />;
    default:
      return null;
  }
};

export default DataModel;
